import * as React from 'react';
import { getAttributionData, getIsBot, recordAttributionAnalytics } from '@/redux/modules/analytics';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import usePrevious from '@/hooks/usePrevious';

/**
 * Record Segment.io attribution data on first page load
 */
const SegmentTracker = () => {
    const attributionData = useSelector(getAttributionData, shallowEqual);
    const isBot = useSelector(getIsBot);
    const prevBidderId = usePrevious(attributionData.bidderId);
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (
            Boolean(attributionData.bidderId) &&
            attributionData.bidderId > 0 &&
            prevBidderId !== attributionData.bidderId &&
            !isBot
        ) {
            dispatch(recordAttributionAnalytics(attributionData));
        }
    }, [attributionData, isBot, prevBidderId, dispatch]);

    return null;
};

export default SegmentTracker;
